import { featureFlags } from "#/config/featureFlags";
import { DepositFeatureFlag } from "#/types/featureFlags";

import { useFeatureFlags } from "./useFeatureFlags";

export const useDepositFeatureFlag = () => {
  const depositFeatureFlag = useFeatureFlags<DepositFeatureFlag>(
    featureFlags.depositConfig,
  );

  return {
    isEnabled: Boolean(depositFeatureFlag?.isEnabled ?? true),
    minAmount: depositFeatureFlag?.minAmount ?? 10,
    depositButtonTooltip: depositFeatureFlag?.tooltip,
    depositButtonTitle: depositFeatureFlag?.title,
  };
};
